module.exports = __webpack_public_path__ + "img/20220415_110248.65ec2883.jpg";